export default __webpack_public_path__ + "static/media/graph-3-large.62d93db1.png";